import type { VerifyAccountOutcome } from '../domain/verifyAccountTypes'
import type { VerifyAccountAPIResponse } from './types'
import { VerifyAccountRequestError } from '../domain/VerifyAccountRequestError'

export function mapVerifyAccountResponse(status: 200 | 400, body: VerifyAccountAPIResponse): VerifyAccountOutcome {
  if (status === 200) {
    if (body.status === 'verifiedAndSignedIn' || body.status === 'alreadyVerified' || body.status === 'verifiedButSignInFailed')
      return body.status

    throw new VerifyAccountRequestError('invalidResponse', status)
  }

  if (body.errorCode === 'ExpiredToken')
    return 'expiredToken'

  if (['ValidationFailed', 'Error', 'Unknown'].includes(String(body.errorCode)))
    return 'error'

  throw new VerifyAccountRequestError('invalidResponse', status)
}
